/**
 * Utilitaires pour la gestion de la langue dans l'application
 */

/**
 * Extrait la langue de base (fr ou en) depuis une locale i18n
 * Gère les formats comme "fr-CA", "en-CA", "fr", "en", etc.
 * @param language La langue depuis i18n.language (ex: "fr-CA", "en-CA", "fr", "en")
 * @returns "fr" ou "en" selon la langue détectée, "fr" par défaut
 */
export const extractBaseLanguage = (language?: string): "fr" | "en" => {
  if (!language) return "fr";
  // Normaliser : extraire "fr" ou "en" depuis "fr-CA", "en-CA", etc.
  return language.startsWith("en") ? "en" : "fr";
};
